module.exports = __webpack_public_path__ + "static/media/coinbase.b1065dd5.svg";